export default __webpack_public_path__ + "static/media/about_the_band.c6f369b2.png";